export enum PurchasingConfigurationGroupEnum {
  authorisation = 'Authorisation Levels',
  settings = 'Settings'
}
